// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CampaignPictures-module__container___rtBWe {
    width: 100%;
    height: calc(100vh - 170px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.CampaignPictures-module__wrapper___fK5yu {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0 1rem;
}

.CampaignPictures-module__buttonContainer___umq2m {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.CampaignPictures-module__downloadButton___w9msk {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 5px 15px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
    border-radius: 0.375rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 170px;
}

    .CampaignPictures-module__downloadButton___w9msk:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

    .CampaignPictures-module__downloadButton___w9msk:active {
        background-color: var(--bmo-primary-color-mint);
    }

    .CampaignPictures-module__downloadButton___w9msk:disabled {
        background-color: #93c5fd;
        cursor: not-allowed;
    }

.CampaignPictures-module__imageContainer___fJULC {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 2rem;
    max-width: 1200px;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
}

.CampaignPictures-module__imageWrapper___SRZAM {
    position: relative;
    cursor: pointer;
    background-color: #f3f4f6;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    flex: 0 1 auto;
    max-width: 600px;
}

.CampaignPictures-module__imageInner___IYqtI {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.CampaignPictures-module__image___U5sUB {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.CampaignPictures-module__image___U5sUB:hover {
    transform: scale(1.05);
}

.CampaignPictures-module__modal___hCkqF {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
}

.CampaignPictures-module__modalContent___qw23O {
    padding: 1rem;
}

.CampaignPictures-module__modalImage___cWXzo {
    max-height: calc(100vh - 300px);
    object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/CampaignPictures/CampaignPictures.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,sGAAsG;IACtG,uBAAuB;IACvB,eAAe;IACf,sCAAsC;IACtC,YAAY;AAChB;;IAEI;QACI,oDAAoD;IACxD;;IAEA;QACI,+CAA+C;IACnD;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB","sourcesContent":[".container {\n    width: 100%;\n    height: calc(100vh - 170px);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0 1rem;\n}\n\n.buttonContainer {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n}\n\n.downloadButton {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 5px 15px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n    border-radius: 0.375rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    width: 170px;\n}\n\n    .downloadButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n    .downloadButton:active {\n        background-color: var(--bmo-primary-color-mint);\n    }\n\n    .downloadButton:disabled {\n        background-color: #93c5fd;\n        cursor: not-allowed;\n    }\n\n.imageContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 2rem;\n    max-width: 1200px;\n    max-height: calc(100vh - 300px);\n    overflow-y: auto;\n}\n\n.imageWrapper {\n    position: relative;\n    cursor: pointer;\n    background-color: #f3f4f6;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    border-radius: 0.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    flex: 0 1 auto;\n    max-width: 600px;\n}\n\n.imageInner {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.image {\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n}\n\n.image:hover {\n    transform: scale(1.05);\n}\n\n.modal {\n    position: fixed;\n    inset: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 50;\n}\n\n.modalContent {\n    padding: 1rem;\n}\n\n.modalImage {\n    max-height: calc(100vh - 300px);\n    object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CampaignPictures-module__container___rtBWe`,
	"wrapper": `CampaignPictures-module__wrapper___fK5yu`,
	"buttonContainer": `CampaignPictures-module__buttonContainer___umq2m`,
	"downloadButton": `CampaignPictures-module__downloadButton___w9msk`,
	"imageContainer": `CampaignPictures-module__imageContainer___fJULC`,
	"imageWrapper": `CampaignPictures-module__imageWrapper___SRZAM`,
	"imageInner": `CampaignPictures-module__imageInner___IYqtI`,
	"image": `CampaignPictures-module__image___U5sUB`,
	"modal": `CampaignPictures-module__modal___hCkqF`,
	"modalContent": `CampaignPictures-module__modalContent___qw23O`,
	"modalImage": `CampaignPictures-module__modalImage___cWXzo`
};
export default ___CSS_LOADER_EXPORT___;
